export type Translations = {
    [key: string]: {
        [lang: string]: string;
    };
};

export const errorTranslations: Translations = {
    "Duplicate entry": {
        "en-US": "The data '{value}' is already in use.",
        "es-ES": "El dato '{value}' ya está en uso.",
        "pt-BR": "O dado '{value}' já está em uso."
    }
};
